import { Outlet } from "react-router-dom";
import { Region } from "../../components";
import { Toolbar } from "../../components/toolbar";
import { ModelProvider, OutlinerProvider } from "../../context";
import { Viewport } from "../../lib";
import { ModelPanel } from "../panels/model";
import { ObjectPanel } from "../panels/object";

type Props = {
    viewport: Viewport;
    loading: boolean;
};

export const StandardViewer = ({ viewport, loading }: Props) => {
    return (
        <>
            <OutlinerProvider viewport={viewport}>
                <Region placement="left">
                    {!loading && (
                        <Outlet
                            context={{
                                viewport: viewport,
                                loading: loading,
                                isMobile: false,
                            }}
                        />
                    )}
                </Region>

                <Region placement="right">
                    {!loading && (
                        <>
                            <ModelPanel viewport={viewport} isMobile={false} loading={loading} />
                            <ObjectPanel viewport={viewport} isMobile={false} loading={loading} />
                        </>
                    )}
                </Region>
            </OutlinerProvider>

            <Region placement="bottom">
                <ModelProvider viewport={viewport}>
                    {!loading && (
                        <>
                            <Toolbar isMobile={false} viewport={viewport} />
                        </>
                    )}
                </ModelProvider>
            </Region>
        </>
    );
};
